import * as React from 'react';
import { Box } from '@mui/material'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export function ScrollableContent(props: Props) {
  return (
    <Box flex="1 0 auto" position="relative" data-id="tidal-stories-scrollable-content">
      <Box position="absolute" top={0} left={0} right={0} bottom={0} overflow="auto">
        {props.children}
      </Box>
    </Box>
  )
}
